import React from 'react';
import PropTypes from 'prop-types';
import { formValues } from 'redux-form';
import ButtonGroupField from './../ButtonGroupField';
import FormField from './../FormField';
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import styles from './../CheckoutForm.scss';
import boxStyles from './../../CategoryPricingTierInfo.scss';

const PaymentMethodFieldset = formValues({ payment_method: 'payment_method' })((props) => {
  const stripeElementStyle = {
    base: {
      '::placeholder': {
        color: '#878e95'
      },
    }
  };

  return (
    <div>
      {props.selectorEnabled &&
        <FormField
          name = "payment_method"
          component={ButtonGroupField}
          data={[{ text: 'Pay by Card', value: 'card' }, { text: 'Pay by Invoice', value: 'bank'}]}
          className="form-control"
        />}
      {props.payment_method === 'card' && <div className="card-payment-method">
        <strong>Supported Cards</strong><br/>
        <div className={styles.cards}>
          <i className="fa fa-cc-visa"/>
          <i className="fa fa-cc-mastercard"/>
          <i className="fa fa-cc-amex"/>
          <i className="fa fa-cc-discover"/>
          <i className="fa fa-cc-jcb"/>
          <i className="fa fa-cc-diners-club"/>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <FormField
              for="card_number"
              label="Card Number"
              error={props.formErrors.get('card_number')}
              required
            >
              <CardNumberElement className="form-control" style={stripeElementStyle}/>
            </FormField>
          </div>
          <div className="col-6 col-sm-4">
            <FormField for="card_expiration_date" label="Exp. Date" error={props.formErrors.get('card_expiry_date')} required>
              <CardExpiryElement className="form-control" style={stripeElementStyle}/>
            </FormField>
          </div>
          <div className="col-6 col-sm-4">
            <FormField for="cvc" label="CVC2 Code" error={props.formErrors.get('card_cvc')} required>
              <CardCVCElement className="form-control" style={stripeElementStyle}/>
            </FormField>
          </div>
          <div className="col-sm-8">
            <FormField
              label="Cardholder Name"
              error={props.formErrors.get('name')}
              name="name"
              component="input"
              type="text"
              className="form-control"
              placeholder="Your Name"
              required
            />
          </div>
        </div>
        <span className={styles.stripe}>Powered by <i className="fa fa-cc-stripe"/></span>
      </div>}
      {props.payment_method === 'bank' && props.isRebooking &&
        <div className={`mb-3 ${boxStyles.infoBox}`}>
          The invoice you receive from us will include our bank details.
          Your payment terms will stay the same as agreed on your account
        </div>
      }
    </div>
  );
});

PaymentMethodFieldset.propTypes = {
  selectorEnabled: PropTypes.bool,
  bankPaymentAvailable: PropTypes.bool,
  formErrors: PropTypes.object,
  isRebooking: PropTypes.bool,
};

PaymentMethodFieldset.defaultProps = {
  selectorEnabled: true,
  bankPaymentAvailable: false,
  isRebooking: false,
};

export default PaymentMethodFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/PaymentMethodFieldset.jsx